// extracted by mini-css-extract-plugin
module.exports = {"header":"_3btZx9TNe1lMngHB","title":"_1whB-P9jqpIRyvZs","body":"XT72D9r45owTxa-h","doneIcon":"_2cBGeBpLPBfuybd_","content":"_1ovJUUsBH2w3K0BF"};